export function getTimeSince(inputDate: Date | string | number): string {
  const date = new Date(inputDate);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();

  const seconds = Math.floor(diffMs / 1000);
  const minutes = Math.floor(diffMs / (1000 * 60));
  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30); // approximate

  if (months >= 1) {
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  }

  if (weeks >= 1) {
    return weeks === 1 ? 'לפני שבוע' : `לפני ${weeks} שבועות`;
  }

  if (days >= 1) {
    return days === 1 ? 'לפני יום' : `לפני ${days} ימים`;
  }

  if (hours >= 1) {
    return hours === 1 ? 'לפני שעה' : `לפני ${hours} שעות`;
  }

  if (minutes >= 1) {
    return minutes === 1 ? 'לפני דקה' : `לפני ${minutes} דקות`;
  }

  return seconds === 1 ? 'לפני שנייה' : `לפני ${seconds} שניות`;
}
